import React from "react";

type RegularVideoCardProps = {
  url: string;
};

const RegularVideoCard: React.FC<RegularVideoCardProps> = ({ url }) => {
  return (
    <video
      src={url}
      controls // Add controls for playback
      className="max-w-full max-h-full object-contain block"
      onError={(e) => {
        console.error("Video failed to load:", url, e);
        // Optionally display a placeholder or error message
      }}
    >
      Your browser does not support the video tag.
    </video>
  );
};

export default RegularVideoCard;
